import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { HelperService } from "../helper/helper.service";
import { IState } from "@models/index";
import {
  fetchCategories,
  setActiveCategory,
} from "@store/category/category.actions";
import {
  getCategoriesSelector,
  GET_ACTIVE_CATEGORY,
} from "@store/category/category.selectors";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ category: IState }>
  ) {}

  getCategoriesSelector(): Observable<any[]> {
    return this.store.select(getCategoriesSelector);
  }

  getActive(): Observable<any> {
    return this.store.select(GET_ACTIVE_CATEGORY);
  }

  setActive(item) {
    this.store.dispatch(setActiveCategory({ item }));
  }

  fetchCategories(page, filterOptions) {
    this.store.dispatch(fetchCategories({ page, filterOptions }));
  }

  getCategories(page: number, filterOptions: any = {}) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/event-categories?${queryString}`);
  }
}
